import {RemoteDeleteFilePreview} from 'data/usecases/private/refund/request-preview';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {DeleteFilePreview} from 'domain/usecases/private/refund/request-preview';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeDeleteFilePreview = (attachmentCode: string): DeleteFilePreview =>
	new RemoteDeleteFilePreview(
		makeBFFApiUrl(`${RefundFlowEndPoints.requestPreviewAttachment}/${attachmentCode}`),
		makeAuthorizeHttpClientDecorator(),
	);
